import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { AgrupacionesGremialesVinculoPueblosDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class AgrupacionesGremialesVinculoPueblosService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getAgrupacionesGremialesVinculoPueblosService(): Observable<BodyListResponse<AgrupacionesGremialesVinculoPueblosDTO>> {
    return this.http.get<BodyListResponse<AgrupacionesGremialesVinculoPueblosDTO>>(API_URL + '/api/v1/agrupacionesGremialesVinculoPueblos/todos');
  }

  guardarAgrupacionesGremialesVinculoPueblosService(agrupacionesGremialesVinculoPueblosDTO: AgrupacionesGremialesVinculoPueblosDTO): Observable<AgrupacionesGremialesVinculoPueblosDTO> {
    return this.http.post<AgrupacionesGremialesVinculoPueblosDTO>(API_URL + '/api/v1/agrupacionesGremialesVinculoPueblos', agrupacionesGremialesVinculoPueblosDTO);
  }

  getAgrupacionesGremialesVinculoPueblosPorCodigoAgrupacionesGremialesVinculosPueblosService(codigoAgrupacionesGremialesVinculosPueblos: string): Observable<BodyResponse<AgrupacionesGremialesVinculoPueblosDTO>> {
    return this.http.get<BodyResponse<AgrupacionesGremialesVinculoPueblosDTO>>(API_URL + '/api/v1/agrupacionesGremialesVinculoPueblos/' + codigoAgrupacionesGremialesVinculosPueblos);
  }

  
  getAgrupacionesGremialesVinculoPueblosPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<AgrupacionesGremialesVinculoPueblosDTO>> {
        return this.http.get<BodyListResponse<AgrupacionesGremialesVinculoPueblosDTO>>(API_URL + '/api/v1/agrupacionesGremialesVinculoPueblos/persona/' + codigoPersona);
  }
}
